import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { Feature } from '../../types';

const AdminFeatures: React.FC = () => {
  const [features, setFeatures] = useState<Feature[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFeatures();
  }, []);

  const loadFeatures = async () => {
    setLoading(true);
    const response = await api.getFeatures();
    if (response.success && response.data) setFeatures(response.data);
    setLoading(false);
  };

  const handleToggle = async (feature: Feature) => {
    const response = await api.updateFeature(feature.id, { isActive: !feature.isActive });
    if (response.success) loadFeatures();
    else alert(response.error);
  };

  if (loading) {
    return <div className="flex items-center justify-center h-64"><div className="w-12 h-12 border-4 border-emerald-500/30 border-t-emerald-500 rounded-full animate-spin" /></div>;
  }

  const categories = [...new Set(features.map(f => f.category))];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">Feature Settings</h1>
        <p className="text-neutral-500">Manage GEO-PRO engine features</p>
      </div>

      {categories.map(category => (
        <div key={category} className="bg-[#121212] border border-[#262626] rounded-2xl overflow-hidden">
          <div className="p-4 border-b border-[#262626]">
            <h3 className="text-sm font-bold text-white uppercase tracking-wider">{category}</h3>
          </div>
          <div className="divide-y divide-[#262626]">
            {features.filter(f => f.category === category).map(feature => (
              <div key={feature.id} className="p-4 flex items-center justify-between hover:bg-[#1a1a1a]">
                <div className="flex items-center gap-4">
                  <span className="text-2xl">{feature.icon}</span>
                  <div>
                    <div className="flex items-center gap-2">
                      <p className="text-white font-medium">{feature.name}</p>
                      <span className="text-neutral-500 text-sm">({feature.code})</span>
                    </div>
                    <p className="text-neutral-500 text-sm">{feature.description}</p>
                  </div>
                </div>
                <button
                  onClick={() => handleToggle(feature)}
                  className={`relative w-12 h-6 rounded-full transition-colors ${feature.isActive ? 'bg-emerald-500' : 'bg-neutral-700'}`}
                >
                  <div className={`absolute w-5 h-5 bg-white rounded-full top-0.5 transition-all ${feature.isActive ? 'left-6' : 'left-0.5'}`} />
                </button>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminFeatures;
